import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';

/** Re-autenticación para firmar (step-up, architecture/08 §4.1): fuerza el ingreso de
 *  credenciales para renovar auth_time y vuelve a la pantalla actual. Un login
 *  silencioso reusaría la sesión sin renovarlo. */
export function useStepUpLogin(): () => void {
  const { loginWithRedirect } = useAuth0();
  return useCallback(() => {
    const returnTo = window.location.pathname + window.location.search;
    void loginWithRedirect({
      appState: { returnTo },
      authorizationParams: { prompt: 'login', max_age: 0 },
    });
  }, [loginWithRedirect]);
}
